import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import Header from "../../../../components/Headers/Header";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import React from "react";
import BarnsListEditor from "../../../../components/Admin/BarnListEditor";

const BarnManagementPage: React.FC = () => {
    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="Barn Management" />
                <IonRow className="ion-justify-content-center">
                    <IonCol size="6">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Barn Merge Page</IonCardTitle>
                            <IonCardContent>
                                <p>This tool allows admin users to select duplicated barns are merge them together.</p>
                                <p>Merge will find all horses, riders, owners, trainer, entries and memberships for each barn and merge them all into one barn.</p>
                                <a href="/index/admin/barns/merge">
                                    <IonButton>
                                        Barn Merge Page
                                    </IonButton>
                                </a>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                    <IonCol size="6">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Barn Elemenets Merge Page</IonCardTitle>
                            <IonCardContent>
                                <p>This tool allows admin users to select a single barns are merge its elements.</p>
                                <p>This tool will find all horses, riders, owners, trainer, entries and memberships for the current barn and allow the user to get rid of duplicates.</p>
                                <a href="/index/admin/barns/merge-elements">
                                    <IonButton>
                                        Barn Merge Elements Page
                                    </IonButton>
                                </a>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>All Barns</IonCardTitle>
                            <IonCardContent>
                                <BarnsListEditor />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default BarnManagementPage;